import { APITypes } from '../../../../primary-record-types';

export const isUpdateValue = (value: FormValueImage): value is UpdateImageValue => {
    return value?.imageValue?.type === 'update';
};

export const isCreateValue = (value: FormValueImage): value is CreateImageValue => {
    return !isUpdateValue(value);
};

/**
 * Helps key the react element in the array.  Index isn't good enough
 * and there isn't anything stable enough on the value to ensure remounts don't happen
 */
type UniqueElementId = {
    uniqueElementId: string;
};

export type UpdateImageValue = {
    imageValue: Omit<APITypes.medicalDataService.ResourceImageUpdateExisting, 'description'>;
    description: string;
} & UniqueElementId;

export type CreateImageValue = {
    imageValue: Omit<APITypes.medicalDataService.ResourceImageCreate, 'description'>;
    description: string;
} & UniqueElementId;

export type FormValueImage = UpdateImageValue | CreateImageValue;
